// FAQ content. The general set mirrors the homepage FAQ; the sensor set is
// drawn from the product owner's manuals (models CFWS10 / CFCL10 / CFBS520).

export const generalFaqs = [
    {
        q: 'Are there any monthly fees or subscriptions?',
        a: 'No. You own the system outright — there are no monthly monitoring fees. You get text, email, and app alerts at no ongoing cost.',
    },
    {
        q: 'What comes in the system?',
        a: 'A Smart Hub (the brains of the network), one or more wireless Water Sensors you place wherever water runs, and the Bedside Control Center that can wake you at night.',
    },
    {
        q: 'Do I need a professional to install it?',
        a: 'No. The sensors are wireless and portable — place them under sinks, by the water heater, behind the fridge — and the system is up and running in minutes.',
    },
    {
        q: 'What happens when a leak is detected?',
        a: 'You get an instant alert by text, email, and in the app — and so do up to 8 emergency contacts you choose. The alert names the exact location, so you know it\'s the kitchen sink or the laundry room before it becomes real damage.',
    },
    {
        q: 'Does it detect freezing too?',
        a: 'Yes. The network detects both flooding and freezing conditions, so you\'re covered against burst-pipe risk as well as leaks.',
    },
    {
        q: 'Will it still work if I move?',
        a: 'Yes. Because the sensors are wireless and portable, the whole system comes with you — unlike wired-in systems that stay with the house.',
    },
    {
        q: 'Is this a product of the USA?',
        a: 'Yes — every device is designed and engineered in the U.S.A.',
    },
    {
        q: 'What is your return policy?',
        a: 'You can return your system within 14 days for a refund if it isn\'t the right fit. Every device is also backed by our manufacturer warranty.',
    },
    {
        q: 'How much does shipping cost?',
        a: 'Shipping is free.',
    },
];

export const sensorFaqs = [
    {
        q: 'How do I test a device?',
        a: 'Press and release the test button on any sensor, Smart Hub, or Bedside Control Center. Have someone watch your other devices, the app, or your phone to confirm the alert is received. It\'s a good idea to test the whole network after installation and periodically after that.',
    },
    {
        q: 'At what temperature does the freeze alert trigger?',
        a: 'The Water Sensor\'s built-in freeze alert activates when the temperature at the sensor drops below 40°F, giving you a warning before pipes have a chance to freeze and burst.',
    },
    {
        q: 'How far can a device be from the Smart Hub?',
        a: 'Devices communicate over a proprietary radio (905.2 / 913.2 MHz) that has been tested to about 200 ft (70 m) in open areas. Walls, appliances, and large metal objects shorten that range. Every device also acts as a repeater, rebroadcasting signals to extend coverage as you add more.',
    },
    {
        q: 'A device shows "offline" in the app — what does that mean?',
        a: 'The network may show a device as offline if the Smart Hub hasn\'t checked in within the last hour. Confirm the Smart Hub is powered on and connected to the internet by Ethernet or Wi-Fi. Once it checks back in, your devices will show as online again.',
    },
    {
        q: 'How do I clean a Water Sensor?',
        a: 'Wipe the exterior and the gold sensor with a soft cloth dampened with warm water. Don\'t use harsh detergents — they can damage the housing and the 23-karat gold contacts.',
    },
    {
        q: 'What powers each device, and how long do batteries last?',
        a: 'Water Sensors run on a long-life internal lithium battery. The Bedside Control Center uses three Duracell DL123 lithium batteries. The Smart Hub is AC powered and needs no batteries.',
    },
    {
        q: 'Where should I place my Water Sensors?',
        a: 'Anywhere water could appear — under sinks, behind the refrigerator, by the water heater, washing machine, and dishwasher, near toilets, and in basements. The sensor alarms the moment water contacts the gold sensor pad.',
    },
    {
        q: 'Where should the Bedside Control Center go?',
        a: 'In a room used for sleeping. The shaker unit slips under the mattress and the speaker sits on the nightstand — a 6 ft cord connects the two. It vibrates the bed and sounds a 520 Hz low-frequency horn during an alarm.',
    },
    {
        q: 'Can moving furniture affect my sensors?',
        a: 'Yes. Moving large metal objects — like a refrigerator or a metal cabinet — near a device can reduce its radio range. Re-test the network after any significant change to your home.',
    },
    {
        q: 'Does the Smart Hub need the internet?',
        a: 'Yes, for remote text, email, and app alerts. Connect it by Ethernet (most reliable) or Wi-Fi (2.4 GHz). The sensors themselves talk to the Smart Hub over their own radio network, and on-device horns still sound locally.',
    },
];
